import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Globe } from "lucide-react";
import { useLang } from "../contexts/LangContext";

export default function Header() {
  const { t, lang, toggle } = useLang();
  const [open, setOpen] = React.useState(false);

  const links = [
    { to: "/", label: t.nav.home, end: true },
    { to: "/format", label: t.nav.formats },
    { to: "/servizi", label: t.nav.services },
    { to: "/eventi", label: t.nav.events },
    { to: "/galleria", label: t.nav.gallery },
    { to: "/contatti", label: t.nav.contact },
  ];

  return (
    <header className="glass-header sticky top-0 z-50" data-testid="site-header">
      <div className="container-x flex items-center justify-between h-24">
        <Link to="/" className="flex items-center gap-3" data-testid="logo-link" aria-label="Scudieri Group">
          <img
            src="/logo.png"
            alt="Scudieri Group"
            className="h-16 md:h-20 w-auto object-contain select-none"
            draggable="false"
            data-testid="site-logo"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-8" data-testid="primary-nav">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`nav-${l.to.replace("/", "") || "home"}`}
              className={({ isActive }) =>
                `font-display text-[15px] tracking-[-0.01em] font-semibold transition-colors ${
                  isActive ? "text-[color:var(--gold)]" : "text-white hover:text-[color:var(--gold)]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={toggle}
            className="hidden md:inline-flex items-center gap-2 text-sm font-display font-semibold text-white hover:text-[color:var(--gold)] transition-colors"
            data-testid="lang-toggle"
            aria-label="Toggle language"
          >
            <Globe className="w-4 h-4" />
            {lang === "it" ? "IT / EN" : "EN / IT"}
          </button>

          <Link
            to="/contatti"
            className="hidden md:inline-flex btn-primary"
            data-testid="header-cta-contact"
          >
            {t.common.requestProposal}
          </Link>

          <button
            className="lg:hidden p-2 text-white"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#0a0a0a]" data-testid="mobile-menu">
          <div className="container-x py-6 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `font-display text-base font-semibold ${
                    isActive ? "text-[color:var(--gold)]" : "text-white"
                  }`
                }
                data-testid={`mobile-nav-${l.to.replace("/", "") || "home"}`}
              >
                {l.label}
              </NavLink>
            ))}
            <button
              onClick={toggle}
              className="text-left font-display font-semibold text-[color:var(--gold)]"
              data-testid="mobile-lang-toggle"
            >
              {lang === "it" ? "EN" : "IT"}
            </button>
            <Link
              to="/contatti"
              onClick={() => setOpen(false)}
              className="btn-primary w-fit"
              data-testid="mobile-cta-contact"
            >
              {t.common.requestProposal}
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
